import { SpyneApp, SpyneTrait, SpyneAppProperties } from "spyne";
import { clone, either, flatten, isEmpty, isNil } from "ramda";

export class UtilTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "util$";
    super(context, traitPrefix);
  }

  static util$GetIframeUrl(iframeFile) {
    return `${SpyneAppProperties.getProp("IFRAMES_PATH")}${iframeFile}`;
  }

  static util$AdjustElHeight(el, heightNum = 100, heightType = "px") {
    el.style.height = `${heightNum}${heightType}`;
  }

  static util$ToKebabCase(str) {
    return (
      str &&
      str
        .match(
          /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g,
        )
        .map((x) => x.toLowerCase())
        .join("-")
    );
  }

  static utils$formatForUrl(str) {
    return str
      .toLowerCase() // Convert to lowercase
      .replace(/[^a-z0-9- ]/g, "") // Remove special characters
      .replace(/ /g, "-"); // Replace spaces with dashes
  }

  static utils$SanitizeForUrl(str) {
    let decodedStr = decodeURIComponent(str).trim();
    return decodedStr.replace(/[^a-zA-Z0-9-_]/g, "");
  }

  static util$KebabToCamelCase(str) {
    if (str.indexOf("-") < 0) {
      return str;
    }

    return str.toLowerCase().replace(/-(.)/g, function (match, group1) {
      return group1.toUpperCase();
    });
  }

  static util$ToCamelCase(str1, str2) {
    /**
     * Converts a string to camelCase.
     * @param {string} str - The string to convert.
     * @returns {string} - The camelCase version of the string.
     */
    function toCamelCase(str) {
      return str
        .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
          index === 0 ? match.toLowerCase() : match.toUpperCase(),
        )
        .replace(/\s+/g, "");
    }

    /**
     * Converts two strings to camelCase and concatenates them.
     * @param {string} str1 - The first string to convert.
     * @param {string} str2 - The second string to convert.
     * @returns {string} - The concatenated camelCase version of the two strings.
     */
    const camelCaseStr1 = toCamelCase(str1);
    const camelCaseStr2 = toCamelCase(str2);
    return (
      camelCaseStr1 +
      camelCaseStr2.charAt(0).toUpperCase() +
      camelCaseStr2.slice(1)
    );
  }

  static util$RemoveSpacesAndSpecialChars(str = "") {
    return str.replace(/[^a-zA-Z0-9]/g, "");
  }

  static util$GetRandInt(max, min = 0) {
    let maxNum = max - min + 1;
    return Math.floor(Math.random() * maxNum) + min;
  }

  static util$SelectRandFromArr(arrSrc, amt = 1) {
    const arr = clone(arrSrc);
    let iter = 0;
    let len, n;
    let splicedArr = [];
    while (iter < amt) {
      len = arr.length - 1;
      // select start splice
      n = Math.floor(Math.random() * len + 1);
      //push slice item into new arr -- cant be duped
      splicedArr.push(arr.splice(n, 1));
      iter++;
    }

    return flatten(splicedArr);
  }

  static util$ScrollLock(el, bool = true) {
    const fn = bool
      ? SpyneApp.pluginsFn.enableScrollLock
      : SpyneApp.pluginsFn.disableScrollLock;
    // fn(el, bool);
  }

  static util$checkForDeeplink(routeData) {
    const expandCard = (page, card) => {
      const { pageId, cardId } = this.props.data;
      return page === pageId && card === cardId;
    };
    const { pageId, cardId } = routeData;
    return expandCard(pageId, cardId);
  }

  static util$GetOffsetTop(props = this.props) {
    const pageContentEl = document.querySelector(".app-page .page-content");
    const pageContentTop = pageContentEl.offsetTop;
    const top = this.props.el.offsetTop + pageContentTop + 16 * 8;
    return top;
  }

  static util$SetRootVal(key, val) {
    document.documentElement.style.setProperty(key, val);
  }

  static util$GetRootVal(rootKey) {
    return getComputedStyle(document.documentElement).getPropertyValue(
      "rootKey",
    );
  }

  static util$GetTemplate(name, filesArr) {
    const cache = {};
    const importAll = (r) => r.keys().forEach((key) => (cache[key] = r(key)));
    importAll(filesArr);
    let file = cache[`./${name}.page.tmpl.html`];
    return file !== undefined ? file : cache[`./page.tmpl.html`];
  }

  static util$GetType(prp) {
    let type = typeof prp;
    if (["number", "boolean", "string"].includes(type)) {
      type = "primitive";
    } else if (type === "object") {
      if (Array.isArray(prp)) {
        type = "array";
      } else if (prp === null) {
        type = "undefined";
      }
    }
    return type;
  }

  static util$EscapeHTMLChars(txt) {
    const text = String(txt);
    //console.log('exape content ',typeof text, {text, txt})

    return text
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  static util$ListClassMethods(instance) {
    let methods = [];
    let proto = Object.getPrototypeOf(instance);

    while (proto && proto !== Object.prototype) {
      methods = methods.concat(
        Object.getOwnPropertyNames(proto).filter(
          (prop) =>
            typeof instance[prop] === "function" && prop !== "constructor",
        ),
      );
      proto = Object.getPrototypeOf(proto);
    }

    return methods;
  }

  static util$CopyToClipboard(text) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
       //console.log("Text copied to clipboard successfully!");
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  }

  static util$OpenWindow(url, tgt = "_blank", policy = "noopener,noreferrer") {
    const newWindow = window.open(url, tgt, policy);
    if (newWindow) {
      // Focus on the new window if it was successfully created
      newWindow.focus();
    } else {
      // Handle the case where the new window could not be created (e.g., due to a popup blocker)
      console.error(
        "Failed to open the new window. It may have been blocked by a popup blocker.",
      );
    }
  }

  static util$CreateObjectPropertiesFromArr(arr) {
    const obj = {};
    arr.forEach((property) => {
      obj[property] = null; // Assigning a default value of null, you can change this to any default value you prefer
    });
    return obj;
  }

  static util$ShallowDeepEqArr(arr1 = [false], arr2 = [""]) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;
  }

  static util$Exists(item) {
    return !either(isNil, isEmpty)(item);
  }
}
